export function headerFunc() {
  // ハンバーガーメニュー実装
  $('.l-header__toggle-button').on('click', function() {
    $('.l-header__toggle-button').toggleClass('l-header__toggle-button--close');
    $('.l-header__nav').toggleClass('l-header__nav--open');
  });

  // スクロールでヘッダーにクラス名を付与
  $(window).scroll(function() {
    let scrollTop = $(this).scrollTop();
    if ( scrollTop > 340 ) {
      $('.l-header').addClass('is--scroll');
    } else {
      $('.l-header').removeClass('is--scroll');
    }
  });
}
